/* eslint-disable @typescript-eslint/no-explicit-any, no-empty, @typescript-eslint/ban-ts-comment */
// Runtime guard to block known proxy/injection domains and remove their scripts.
const BLOCK_HOSTS = ['lovableproject.com', 'cdn.gpteng.co'];

function matchesBlocked(url: string | null | undefined) {
  if (!url) return false;
  try {
    const u = new URL(url, location.origin);
    return BLOCK_HOSTS.some(h => u.hostname.includes(h));
  } catch {
    return BLOCK_HOSTS.some(h => (url || '').includes(h));
  }
}

// Remove any script tags that reference blocked hosts
try {
  const scripts = Array.from(document.scripts);
  for (const s of scripts) {
    if (s.src && matchesBlocked(s.src)) {
      // remove script node so it cannot execute
      s.remove();
      try {
        // also revoke src to be extra-safe
        // @ts-ignore
        s.src = '';
      } catch {}
      console.warn('[block-proxy] removed blocked script', s.src);
    }
  }
} catch (err) {
  // ignore
}

// Override fetch to block requests to blocked hosts
try {
  const origFetch = window.fetch.bind(window);
  window.fetch = async (input: RequestInfo, init?: RequestInit) => {
    const url = typeof input === 'string' ? input : input instanceof Request ? input.url : '';
    try {
      if (matchesBlocked(url)) {
        console.warn('[block-proxy] blocked fetch to', url);
        return new Response(null, { status: 403, statusText: 'Blocked by block-proxy' });
      }
    } catch (e) {
      console.warn('[block-proxy] error while checking fetch url', e);
    }
    return origFetch(input, init);
  };
} catch {}

// Override XMLHttpRequest open to detect and block requests
try {
  // keep original
  const OrigX = (window as any).XMLHttpRequest;
  (window as any).XMLHttpRequest = function () {
    const xhr = new OrigX();
    const origOpen = xhr.open;
    xhr.open = function (...args: any[]) {
      const urlArg = args[1];
      const s = typeof urlArg === 'string' ? urlArg : urlArg ? String(urlArg) : '';
      if (matchesBlocked(s)) {
        console.warn('[block-proxy] blocked XHR to', s);
        throw new Error('Blocked by block-proxy');
      }
      return origOpen.apply(this, args as any);
    };
    return xhr;
  } as any;
} catch {}

// expose for debugging
// @ts-ignore
window.__blockProxy = { hosts: BLOCK_HOSTS };

export {};
